import React from 'react';
import '../App.css';
import '../bootstrap.css';
import FoodLoggingForm from '../main/foodLogging/FoodLoggingForm2';
import { DEFAULT_TIMEZONE } from '../helpers/Util';

let _ = require('lodash');

const SECTION_TITLE = {
  Uploader: 'uploader',
  Annotator: 'annotator',
  ErrorLogs: 'errorLogs',
  ChatSearch: 'chatSearch',
  EraseUser: 'eraseUser',
  NutritionAnalysis: 'nutrionAnalysis',
  FAQ: 'FAQs',
  Broadcast: 'broadcast',
  CompleteOnboarding: 'completeOnboarding'
};

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: SECTION_TITLE.Uploader,
      userId: ''
    }
  }

  handleOptionChange(e) {
    this.setState({
      selectedOption: e.target.value
    });
  }

  userIdChange(e) {
    this.setState({
      userId: e.target.value
    });
  }

  autofillTestTextChange(e) {
    this.setState({
      autofillTestText: e.target.value
    });
  }

  autofillTestTextSubmit(e) {
    e.preventDefault();
    this.setState({
      autofillTestTextFinal: this.state.autofillTestText
    })
  }

  render() {
    let ui = (
      <div>
        <h3>Add or Update Foods</h3>
        <br />
        <div style={{ margin: '10px' }}> User id (optional): <input value={this.state.userId} onChange={this.userIdChange.bind(this)} /> </div>
        <FoodLoggingForm fromTooling={true} userId={this.state.userId} userName={this.state.userId} timezoneOffset={DEFAULT_TIMEZONE} isLargeScreen={true}
          requiredNutritionData={{}} highlightedFood={this.state.autofillTestTextFinal === undefined ? '' :
            {
              name: this.state.autofillTestTextFinal, timestamp: Date.now()
            }
          }
          adminId={this.props.adminId} />
        <hr />
        Test autofill text: <input type='text' onChange={this.autofillTestTextChange.bind(this)} value={this.state.autofillTestText === undefined ? '' : this.state.autofillTestText} />
        <input type='submit' onClick={this.autofillTestTextSubmit.bind(this)} />
      </div>
    );

    return (
      <div style={{ margin: '10px' }}>
        {ui}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/datatool/Main.js